export const getOwnerWord = (count: number): string => {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod100 >= 11 && mod100 <= 14) return "владельцев";
    if (mod10 === 1) return "владелец";
    if (mod10 >= 2 && mod10 <= 4) return "владельца";
    return "владельцев";
};

export const getAccidentWord = (count: number): string => {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod10 === 1 && mod100 !== 11) return "авария";
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return "аварии";
    return "аварий";
};